import React from "react";

import { getResizedImageURL } from "../../utils";
import { Wrapper } from "../../Wrapper";

import styles from "../styles/FullWidthImage.module.scss";

export const FullWidthImage = ({ data }: any) => {
  const imageResized = getResizedImageURL(data.image.url, 1600) || "";
  return (
    <Wrapper style={{ marginBottom: "30px" }}>
      <img className={styles.image} src={imageResized} alt={data.image.alt} />
      {data.image.caption && (
        <p className={styles.caption}>{data.image.caption}</p>
      )}
    </Wrapper>
  );
};
